import React, {useEffect} from 'react';
import ReduxToastr from 'react-redux-toastr';
import {useDispatch, useSelector} from 'react-redux';
import { Sidebar, Sticky } from 'semantic-ui-react';

import {MixpanelProvider, useMixpanel} from 'react-mixpanel-browser';

import { isMenuVisible } from './components/NavBottomBar/reducer';
import { closeMenu } from './components/NavBottomBar/actions';
import NavTopBar from './components/NavTopBar';
import NavBottomBar from './components/NavBottomBar';
import SideMenu from './views/SideMenu';

import './App.css';
import {MIXPANEL_API_KEY} from "./config/secrets";
import {isSearchVisible} from "./components/NavTopBar/reducer";
import {closeSearch} from "./components/NavTopBar/actions";

import {store} from "./configureStore";
import {useNavigate} from "react-router-dom";
import {getAuthToken, getUserData, getUserLoggedIn} from "./components/UserLogin/reducer";
import {getLocationData} from "./components/GeoLocation/reducer";
import {isArray} from "lodash";
const MIXPANEL_TOKEN = MIXPANEL_API_KEY;

const MIXPANEL_CONFIG = {
    track_pageview: true, // Set to `false` by default
}

function App (props) {

  const router = useSelector((state) => state.router);
  const defaultProps = {
    navigate: useNavigate(),
    dispatch: useDispatch(),
    searchVisible: useSelector((state) => isSearchVisible(state.navtopbar)),
    menuVisible: useSelector((state) => isMenuVisible(state.navbottombar)),
    userData: useSelector((state) => getUserData(state.userLogin)),
    userLocation: useSelector((state) => getLocationData(state.userLocation)),
    isLoggedIn: useSelector((state) => getUserLoggedIn(state.userLogin)),
    token: useSelector((state) => getAuthToken(state.userLogin)),
    mixpanel: useMixpanel(),
    routeAction: router.action,
    location: router.location,
    previousLocations: router.previousLocations,
    isPageReloaded: router.action === 'POP' && isArray(router.previousLocations) && _.size(router.previousLocations) === 1,
  }

  const {children} = props;
  const {routeAction, location, previousLocations, menuVisible, searchVisible, dispatch} = defaultProps;

  if ( process.env.REACT_APP_ENV !== 'production') {
    console.log('App - глобальные стейты REDUX', store.getState());
    console.log('App - router-redux action, location, previous', routeAction, location, previousLocations);
  }

  function hideBars () {

    if (menuVisible)
      dispatch(closeMenu());

    if (searchVisible)
      dispatch(closeSearch());
  }

  return (
      <MixpanelProvider config={MIXPANEL_CONFIG} token={MIXPANEL_TOKEN}>
      <div>
        <ReduxToastr
          timeOut={4000}
          newestOnTop
          preventDuplicates
          position="top-center"
          transitionIn="fadeIn"
          transitionOut="fadeOut"
        />
        <NavTopBar {...defaultProps}/>
        <Sidebar.Pushable style={{ transform: 'none' }}>
          <Sticky>
            <SideMenu {...defaultProps}/>
          </Sticky>
          <Sidebar.Pusher
            dimmed={menuVisible || searchVisible}
            onClick={hideBars}
            style={{ minHeight: '100vh' }}
          >
            {children}
          </Sidebar.Pusher>
        </Sidebar.Pushable>
        <NavBottomBar {...defaultProps}/>
      </div>
      </MixpanelProvider>
    );
}

/*export function withRouter (Component) {
    const router = useSelector((state) => state.router);

    const defaultProps = {
      navigate: useNavigate(),
      dispatch: useDispatch(),
      searchVisible: useSelector((state) => isSearchVisible(state.navtopbar)),
      menuVisible: useSelector((state) => isMenuVisible(state.navbottombar)),
      userData: useSelector((state) => getUserData(state.userLogin)),
      userLocation: useSelector((state) => getLocationData(state.userLocation)),
      isLoggedIn: useSelector((state) => getUserLoggedIn(state.userLogin)),
      token: useSelector((state) => getAuthToken(state.userLogin)),
      mixpanel: useMixpanel(),
      routeAction: router.action,
      location: router.location,
      previousLocations: router.previousLocations,
    }
    const {menuVisible, searchVisible, dispatch} = defaultProps;

    useEffect(() => {
      if (menuVisible)
        dispatch(closeMenu());

      if (searchVisible)
        dispatch(closeSearch());
    }, []);

    return <Component {...defaultProps}/>;
}*/

export default App;